// ============================================================
//  wiwify-cart-modal-fix.js
//  layout/theme.liquid → </body> öncesi (koşulsuz)
//
//  Fix 1 : Modal altındaki boş beyaz alan (4 CSS katmanı)
//  Fix 2 : Modal açıkken arka sayfa scroll engeli
//  Fix 3 : Detay ekranına "Sepete Ekle" butonu
//          - WiwiPoint Kullan → Kullan → detay
//          - Kazandığın Ödüller → herhangi ödül → detay
//
//  Teknik:
//    - XHR + fetch intercept: iframe DOM'a girer girmez kurulur
//    - Appstle'ın TÜM API yanıtlarından reward/handle map biriktirilir
//    - React fiber traversal: detay kartı DOM'undan productData çıkarılır
//    - Image URL parse: Shopify CDN URL'inden handle çıkarılır
//    - Fallback: Shopify predictive search ile ürün adından handle bulunur
//    - "Sepete Ekle" tıklanınca:
//        1. "Kodu Uygula" otomatik tıklanır
//        2. Kısa bekleme (Appstle XHR'ı tamamlasın)
//        3. Ürün sepete eklenir
//        4. Modal kapatılır, sepet drawer açılır
// ============================================================
(function () {
  'use strict';

  var STYLE_ID = 'wiwify-cart-modal-fix';
  var BTN_CLS  = 'wiwify-atc-btn';

  // ── Yardımcılar ──────────────────────────────────────────────────────
  function getIframe() { return document.getElementById('appstle_loyalty_cart_widget_iframe'); }
  function getIDoc() {
    var f = getIframe();
    try { return f ? (f.contentDocument || f.contentWindow.document) : null; } catch(e) { return null; }
  }
  function getIWin() {
    var f = getIframe();
    try { return f ? f.contentWindow : null; } catch(e) { return null; }
  }

  function extractHandle(raw) {
    if (!raw) return null;
    try {
      var arr = JSON.parse(raw);
      var obj = Array.isArray(arr) ? arr[0] : arr;
      return obj.productHandle || obj.handle || null;
    } catch(e) {
      var m = (raw || '').match(/productHandle[^:]*:[\\"\s]*([a-z0-9][a-z0-9-]+)/i);
      return m ? m[1] : null;
    }
  }

  // ── NEW: Shopify CDN URL'inden handle çıkar ─────────────────────────
  // cdn.shopify.com/s/files/.../products/HANDLE_variant.ext
  function extractHandleFromImageUrl(url) {
    if (!url) return null;
    var m = url.match(/\/products\/([a-z0-9][a-z0-9_-]+?)(?:_\d+x\d*|_[a-z]+)?\.(?:png|jpg|jpeg|webp|gif)/i);
    if (m) return m[1].replace(/_/g, '-').toLowerCase();
    var m2 = url.match(/\/products\/([a-z0-9][a-z0-9_-]+)/i);
    return m2 ? m2[1].replace(/_/g, '-').toLowerCase() : null;
  }

  // ── NEW: React fiber traversal — DOM elementinden reward verisini bul ──
  function getReactFiber(el) {
    if (!el) return null;
    var key = Object.keys(el).find(function(k) {
      return k.startsWith('__reactFiber$') || k.startsWith('__reactInternalInstance$');
    });
    return key ? el[key] : null;
  }

  function extractRewardFromFiber(el, maxDepth) {
    if (!el) return null;
    maxDepth = maxDepth || 25;
    var fiber = getReactFiber(el);
    if (!fiber) return null;

    var node = fiber;
    var depth = 0;
    while (node && depth < maxDepth) {
      var props = node.memoizedProps || node.pendingProps || {};

      // Doğrudan productHandle varsa
      if (props.productHandle) return { handle: props.productHandle };

      // reward, item, redeemRule gibi objeler
      var candidates = [
        props.reward, props.rewardItem, props.redeemRuleItem,
        props.item, props.redeemRule, props.earnedReward,
        props.redeemedReward, props.selectedReward
      ];
      for (var i = 0; i < candidates.length; i++) {
        var r = candidates[i];
        if (r && typeof r === 'object') {
          var h = r.productHandle || extractHandle(r.productData);
          if (h) return { handle: h, reward: r };
          if (r.discountCode) return { reward: r };
        }
      }

      // children.props içinde de olabilir
      if (props.children && typeof props.children === 'object' && !Array.isArray(props.children) && props.children.props) {
        var cp = props.children.props;
        if (cp.productHandle) return { handle: cp.productHandle };
        var cCandidates = [cp.reward, cp.rewardItem, cp.redeemRuleItem, cp.item];
        for (var j = 0; j < cCandidates.length; j++) {
          var cr = cCandidates[j];
          if (cr && typeof cr === 'object') {
            var h2 = cr.productHandle || extractHandle(cr.productData);
            if (h2) return { handle: h2, reward: cr };
          }
        }
      }

      node = node.return;
      depth++;
    }
    return null;
  }

  // ── NEW: Detay ekranındaki tüm elementlerden handle çıkar ───────────
  function extractHandleFromDetailScreen(doc) {
    if (!doc) return null;

    // Strateji A: React fiber — kart elementlerinden
    var selectors = [
      '.al-h-fit.al-rounded-xl.al-shadow-md',
      '.al-bg-white.al-rounded-lg',
      '.al-rewards-discount-code',
      '[class*="reward-detail"]',
      '[class*="RewardDetail"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = doc.querySelector(selectors[i]);
      if (el) {
        var result = extractRewardFromFiber(el);
        if (result && result.handle) return result.handle;
      }
    }

    // Strateji B: Shopify CDN görselleri
    var imgs = doc.querySelectorAll('img[src*="cdn.shopify"], img[src*="/products/"]');
    for (var k = 0; k < imgs.length; k++) {
      var src = imgs[k].src || imgs[k].getAttribute('src') || '';
      if (src.indexOf('/products/') !== -1) {
        var h = extractHandleFromImageUrl(src);
        if (h) return h;
      }
    }

    // Strateji C: Background image
    var bgEls = doc.querySelectorAll('[style*="cdn.shopify"]');
    for (var m = 0; m < bgEls.length; m++) {
      var bgMatch = (bgEls[m].style.backgroundImage || '').match(/url\(["']?([^"')]+)/);
      if (bgMatch && bgMatch[1].indexOf('/products/') !== -1) {
        var h2 = extractHandleFromImageUrl(bgMatch[1]);
        if (h2) return h2;
      }
    }

    return null;
  }

  // ── 1. CSS Fix ────────────────────────────────────────────────────────
  function injectCSS(doc) {
    if (!doc || doc.getElementById(STYLE_ID)) return;
    var s = doc.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.loyaltyCartWidget{margin-bottom:0!important}' +
      '.al-p-0.al-overflow-auto.al-flex-grow{padding-bottom:0!important;overscroll-behavior:contain!important;-webkit-overflow-scrolling:touch!important}' +
      '.al-grid.al-gap-4.al-pb-4.al-overflow-y-auto{padding-bottom:8px!important}' +
      '.al-bg-white.al-rounded-lg>.al-pt-4{display:none!important}' +
      'html,body{overflow:hidden!important;overscroll-behavior:none!important}';
    doc.head.appendChild(s);
  }

  // ── 2. Scroll lock ────────────────────────────────────────────────────
  var _scrollY = 0, _locked = false;
  function preventScroll(e) { e.preventDefault(); }

  function lockScroll() {
    if (_locked) return;
    _locked = true;
    _scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    window.addEventListener('wheel',     preventScroll, { passive: false });
    window.addEventListener('touchmove', preventScroll, { passive: false });
    window.scrollTo(0, _scrollY);
  }
  function unlockScroll() {
    if (!_locked) return;
    _locked = false;
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    window.removeEventListener('wheel',     preventScroll);
    window.removeEventListener('touchmove', preventScroll);
    window.scrollTo(0, _scrollY);
  }

  // ── 3. XHR + fetch intercept ─────────────────────────────────────────
  // GENİŞLETİLDİ: Sadece /redeem-points değil, tüm Appstle API yanıtlarını
  // tarayarak reward/product verisi çıkarır.
  function installXHR(win) {
    if (!win || win.__wiwifyXHR) return;
    win.__wiwifyXHR = true;
    win.__handles   = {};
    win.__rewards   = [];

    // — Ortak reward işleme —
    function processRewards(rewards) {
      if (!Array.isArray(rewards)) return;
      rewards.forEach(function(r) {
        if (!r || typeof r !== 'object') return;
        var h = r.productHandle || extractHandle(r.productData);
        if (r.discountCode && h) win.__handles[r.discountCode] = h;
        // dedup
        var key = r.id || r.discountCode || JSON.stringify(r).substring(0, 60);
        win.__rewards = win.__rewards.filter(function(x) {
          return (x.id || x.discountCode || '') !== key;
        });
        win.__rewards.push(r);
      });
    }

    function isAppstleUrl(url) {
      return (
        url.indexOf('/cp/api/') !== -1 ||
        url.indexOf('/redeem-points') !== -1 ||
        url.indexOf('/rewards') !== -1 ||
        url.indexOf('/loyalty') !== -1 ||
        url.indexOf('appstle') !== -1
      );
    }

    function tryExtract(text) {
      try {
        var d = JSON.parse(text);
        // Her olası alan adını kontrol et
        ['rewards','redeemedRewards','earnedRewards','customerRewards','redeemRules'].forEach(function(k) {
          if (d[k]) processRewards(d[k]);
        });
        if (d.reward && typeof d.reward === 'object') processRewards([d.reward]);
        if (Array.isArray(d) && d.length && (d[0].discountCode || d[0].productData)) processRewards(d);
      } catch(e) {}
    }

    // — XMLHttpRequest intercept —
    var Orig = win.XMLHttpRequest;

    function WXHR() {
      var xhr = new Orig();
      var _url = '';

      xhr.open = function(m, u) {
        _url = u || '';
        return Orig.prototype.open.apply(xhr, arguments);
      };
      xhr.send = function(body) {
        if (isAppstleUrl(_url)) {
          xhr.addEventListener('load', function() {
            try { if (xhr.status === 200 && xhr.responseText) tryExtract(xhr.responseText); } catch(e) {}
          });
        }
        return Orig.prototype.send.apply(xhr, arguments);
      };

      return xhr;
    }
    WXHR.prototype = Orig.prototype;
    win.XMLHttpRequest = WXHR;

    // — fetch intercept —
    if (win.fetch && !win.__wiwifyFetch) {
      win.__wiwifyFetch = true;
      var origFetch = win.fetch.bind(win);
      win.fetch = function() {
        var url = arguments[0];
        var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
        var p = origFetch.apply(win, arguments);
        if (isAppstleUrl(urlStr)) {
          p.then(function(resp) {
            resp.clone().text().then(function(t) { tryExtract(t); }).catch(function(){});
          }).catch(function(){});
        }
        return p;
      };
    }
  }

  // ── 4. Shopify: ürün adından handle bul (fallback) ───────────────────
  function searchHandleByTitle(title) {
    if (!title) return Promise.resolve(null);
    var clean = title.replace(/\s+/g, ' ').trim().substring(0, 80);
    return window.fetch(
      '/search/suggest.json?q=' + encodeURIComponent(clean) +
      '&resources[type]=product&resources[limit]=3'
    )
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) return null;
      var tl = clean.toLowerCase();
      var best = products[0];
      for (var i = 0; i < products.length; i++) {
        if (products[i].title.toLowerCase().indexOf(tl.substring(0, 20)) !== -1) {
          best = products[i]; break;
        }
      }
      return best.handle;
    })
    .catch(function() { return null; });
  }

  // ── NEW: Handle doğrulama ────────────────────────────────────────────
  function validateHandle(handle) {
    if (!handle) return Promise.resolve(null);
    return window.fetch('/products/' + handle + '.js')
      .then(function(r) { return r.ok ? handle : null; })
      .catch(function() { return null; });
  }

  // ── 5. Shopify cart ───────────────────────────────────────────────────
  function getVariantId(handle) {
    return window.fetch('/products/' + handle + '.js')
      .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(p) {
        var vs = p.variants || [];
        var v  = vs.find(function(x) { return x.available; }) || vs[0];
        return v ? v.id : null;
      });
  }

  function addToCartFetch(variantId) {
    return window.fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
    .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh',              { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated',              { bubbles: true }));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
    setTimeout(function() {
      var btn = document.querySelector(
        'a[href="/cart"].header__icon, ' +
        'button[aria-controls*="cart"], ' +
        '.js-drawer-open-cart, ' +
        '[data-cart-drawer-trigger]'
      );
      if (btn) btn.click();
    }, 300);
  }

  function closeModal(doc) {
    if (!doc) return;
    var btns = doc.querySelectorAll('.al-cursor-pointer');
    var closeBtn = btns[btns.length - 1];
    if (closeBtn) closeBtn.click();
  }

  // ── 6. Buton ─────────────────────────────────────────────────────────
  function createBtn(doc) {
    var btn = doc.createElement('button');
    btn.type      = 'button';
    btn.className = BTN_CLS;
    btn.textContent = 'Sepete Ekle';
    btn.style.cssText = [
      'display:flex', 'width:100%', 'align-items:center', 'justify-content:center',
      'padding:11px 16px', 'margin-top:8px',
      'background-color:#F9E318', 'color:#000000',
      'font-size:14px', 'font-weight:600', 'font-family:inherit',
      'letter-spacing:0.02em', 'border:none', 'border-radius:4px',
      'cursor:pointer', 'transition:opacity 0.15s ease', 'box-sizing:border-box',
    ].join(';');
    btn.addEventListener('mouseover', function() { btn.style.opacity = '0.85'; });
    btn.addEventListener('mouseout',  function() { btn.style.opacity = '1'; });
    return btn;
  }

  function setBtnState(btn, state) {
    var S = {
      idle:    { t: 'Sepete Ekle',              bg: '#F9E318', c: '#000000', d: false },
      loading: { t: 'Ekleniyor\u2026',          bg: '#F9E318', c: '#000000', d: true  },
      success: { t: '\u2713 Sepete Eklendi',    bg: '#22c55e', c: '#ffffff', d: false },
      error:   { t: 'Hata \u2014 Tekrar Dene', bg: '#ef4444', c: '#ffffff', d: false },
    };
    var s = S[state] || S.idle;
    btn.textContent           = s.t;
    btn.style.backgroundColor = s.bg;
    btn.style.color           = s.c;
    btn.disabled              = s.d;
    if (state === 'success' || state === 'error') {
      setTimeout(function() { setBtnState(btn, 'idle'); }, 2500);
    }
  }

  // ── 7. Detay ekranı butonu ────────────────────────────────────────────
  function getTitleFromDetail(doc) {
    var titleSelectors = [
      '.al-flex.al-justify-between .al-font-semibold',
      '.al-flex.al-justify-between h4',
      '.al-flex.al-items-center h4',
      '.al-flex.al-items-center .al-font-semibold',
      '.al-h-fit .al-font-semibold',
      '.al-rounded-xl .al-font-semibold',
      '.al-shadow-md .al-font-semibold',
      'h4.al-font-semibold',
      'h4',
      '.al-font-semibold'
    ];
    // UI label'lerini filtrele
    var skipWords = ['Kullan','Kapat','Geri','WiwiPoint','Sepet','Ödül',
                     'Kazandığın','Kodu','İndirim','Puan','Seviye','Uygula',
                     'Kopyala','Hediye','Kodunuz'];

    for (var i = 0; i < titleSelectors.length; i++) {
      var els = doc.querySelectorAll(titleSelectors[i]);
      for (var j = 0; j < els.length; j++) {
        var txt = els[j].textContent.trim();
        if (txt.length < 5) continue;
        var isUI = skipWords.some(function(w) { return txt.indexOf(w) !== -1; });
        if (!isUI) return txt;
      }
    }
    return '';
  }

  function bindClick(btn, getHandlePromise, doc) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      setBtnState(btn, 'loading');

      // 1. "Kodu Uygula" otomatik tıkla
      var applyBtn = doc && doc.querySelector('.loyalty-reward-detail-copy-discount-code-button');
      if (applyBtn && !applyBtn.disabled) applyBtn.click();

      // 2. Handle bul → variant al → sepete ekle
      getHandlePromise()
        .then(function(handle) {
          if (!handle) throw new Error('handle not found');
          return getVariantId(handle);
        })
        .then(function(variantId) {
          if (!variantId) throw new Error('variant not found');
          return new Promise(function(resolve, reject) {
            setTimeout(function() {
              addToCartFetch(variantId).then(resolve).catch(reject);
            }, 800);
          });
        })
        .then(function() {
          setBtnState(btn, 'success');
          setTimeout(function() {
            closeModal(doc);
            openCartDrawer();
          }, 500);
        })
        .catch(function(err) {
          console.warn('[wiwify-atc] error:', err && err.message);
          setBtnState(btn, 'error');
        });
    });
  }

  function injectDetailBtn(doc, win) {
    if (!doc || !win) return;
    if (doc.querySelector('.' + BTN_CLS + '[data-ctx="detail"]')) return;

    var card = doc.querySelector(
      '.al-h-fit.al-rounded-xl.al-shadow-md.al-text-sm.al-bg-white.al-items-center'
    );
    if (!card) return;

    var codeSpan = doc.querySelector('.al-rewards-discount-code');
    if (!codeSpan) return;
    var couponCode = codeSpan.textContent.trim();
    if (!couponCode) return;

    var btn = createBtn(doc);
    btn.setAttribute('data-ctx',  'detail');
    btn.setAttribute('data-code', couponCode);

    bindClick(btn, function() {
      // ─── GENİŞLETİLMİŞ HANDLE BULMA ZİNCİRİ (5 ADIM) ───

      // Adım 1: XHR/fetch intercept map'inden (yeni ödüller)
      var h = (win.__handles || {})[couponCode];
      if (h) {
        console.log('[wiwify-atc] Adım 1 — XHR map hit:', h);
        return Promise.resolve(h);
      }

      // Adım 2: rewards array'inden (XHR/fetch'ten birikmiş)
      var found = (win.__rewards || []).find(function(r) {
        return r.discountCode === couponCode;
      });
      if (found) {
        h = found.productHandle || extractHandle(found.productData);
        if (h) {
          console.log('[wiwify-atc] Adım 2 — rewards array hit:', h);
          return Promise.resolve(h);
        }
      }

      // Adım 3: React fiber traversal (detay kartı DOM'undan)
      h = extractHandleFromDetailScreen(doc);
      if (h) {
        console.log('[wiwify-atc] Adım 3 — fiber/image hit:', h);
        return validateHandle(h).then(function(valid) {
          if (valid) return valid;
          console.log('[wiwify-atc] Adım 3 — doğrulanamadı, title fallback');
          return doTitleSearch();
        });
      }

      // Adım 4: Detay görselinden CDN URL parse
      var detailImg = doc.querySelector(
        '.al-h-fit img[src*="cdn.shopify"], ' +
        '.al-rounded-xl img[src*="cdn.shopify"], ' +
        'img[src*="/products/"]'
      );
      if (detailImg) {
        var imgHandle = extractHandleFromImageUrl(detailImg.src);
        if (imgHandle) {
          console.log('[wiwify-atc] Adım 4 — image URL hit:', imgHandle);
          return validateHandle(imgHandle).then(function(valid) {
            if (valid) return valid;
            console.log('[wiwify-atc] Adım 4 — doğrulanamadı, title fallback');
            return doTitleSearch();
          });
        }
      }

      // Adım 5: Shopify predictive search (ürün adından)
      return doTitleSearch();

      function doTitleSearch() {
        var title = getTitleFromDetail(doc);
        console.log('[wiwify-atc] Adım 5 — title search:', title);
        return searchHandleByTitle(title);
      }
    }, doc);

    var wrapper = doc.createElement('div');
    wrapper.style.cssText = 'padding:0 16px 12px 16px;box-sizing:border-box;';
    wrapper.appendChild(btn);
    card.appendChild(wrapper);
  }

  // ── 8. Ekran izleyici ─────────────────────────────────────────────────
  function watchScreen(doc, win) {
    if (!doc) return;
    function check() {
      if (doc.querySelector('.al-rewards-discount-code')) {
        injectDetailBtn(doc, win);
      }
    }
    var mo = new MutationObserver(check);
    mo.observe(doc.body, { childList: true, subtree: true });
    check();
  }

  // ── 9. iframe hazırlık ────────────────────────────────────────────────
  function setupIframe() {
    var doc = getIDoc();
    var win = getIWin();
    if (!doc || !win) return;
    injectCSS(doc);
    installXHR(win);
    watchScreen(doc, win);
  }

  // ── 10. iframe open/close izle ────────────────────────────────────────
  function watchIframe() {
    var f = getIframe();
    if (!f) return;
    var lastOpen = null;

    var mo = new MutationObserver(function() {
      var open = f.classList.contains('open');
      if (open && lastOpen !== true)  { lastOpen = true;  lockScroll(); setupIframe(); }
      if (!open && lastOpen !== false){ lastOpen = false; unlockScroll(); }
    });
    mo.observe(f, { attributes: true, attributeFilter: ['class'] });

    if (f.classList.contains('open')) { lastOpen = true; lockScroll(); setupIframe(); }
  }

  // ── 11. Başlat ────────────────────────────────────────────────────────
  function init() {
    var f = getIframe();
    if (f) {
      var w = getIWin();
      if (w) installXHR(w);
      watchIframe();
    } else {
      var obs = new MutationObserver(function(mutations, self) {
        var f2 = getIframe();
        if (!f2) return;
        self.disconnect();
        var w2 = getIWin();
        if (w2) installXHR(w2);
        watchIframe();
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();